import { useContext, useEffect } from 'react';
import { UserContext } from '@incentivegames/ig-frontend-common/lib/contexts/userContext';
import i18n from 'theme/i18n';
import config from 'theme/config';
import { devTools } from '../../common/devtools';

export const useDefaultLanguage = () => {
  const userContext = useContext(UserContext);
  useEffect(() => {
    const languageParam = new URLSearchParams(window.location.search).get(config.settings.languageCodeIdentifier);
    //only use the default language if there is no language param and user.lang is undefined
    devTools.log('languageParam', languageParam);
    devTools.log('userContext.user.lang', userContext.user.lang);
    if (!userContext.user.lang && !languageParam) {
      const defaultLanguage = config.settings.defaultLanguage;
      userContext.setLanguage(defaultLanguage);
      i18n.changeLanguage(defaultLanguage);
    }
  }, [userContext, userContext.user.lang]);
};
